import { FieldViewModel, IComponentContext } from "../exports"
import { ISeedRatePlan } from "../types"

export class CalcSeedMapCmd {

    targetPlan: ISeedRatePlan
    targetCropping: FieldViewModel[]
    sowingDate: Date
    targetPopulation: number

    canExecute: (target: any) => boolean
    execute: (target: any) => void

    constructor(protected ctxt: IComponentContext, public text?: string, public icon?: string) {
    }

    calcSeedRatesMap(plan?: ISeedRatePlan, cropping?: FieldViewModel[], restart?: boolean): IComponentContext {

        this.targetPlan = plan || this.targetPlan
        this.targetCropping = cropping || this.targetCropping

        return this.ctxt.startComponent({ component: "omnia-seeds-map-calc-form", execArguments: this, restartCurrent: restart })

    }

}
